<template>
    <div>
      <!-- Contenido para usuarios NO STAFF -->
      <div v-if="!isStaffUser()" class="glossary-container">
        <div class="header-ranking">
          <div class="d-flex align-items-center">
            <img src="/img-version2/icons/season/closed-chest.png" alt="close-chest" class="me-2">
            <h5 class="text-title-bat text-indigo">Tu ranking</h5>
          </div>
          <h6 class="text-bat lh-base">
            Prepárate para desafíos nuevos cada semana y gana increíbles sorpresas. Cada cohete representa algo diferente
          </h6>
        </div>
        <div class="grid-level text-bat">
          <div class="grid-item-level">
            <img src="/img-version2/icons/rocket-orange.svg" alt="Cofre" class="img-fluid" @click="showModalLevels = true">
            <div class="text-content">
              <h6>Cohete Naranja</h6>
              <p>Avanza resolviendo las actividades.</p>
            </div>
          </div>
          <div class="grid-item-level">
            <img src="/img-version2/icons/rocket-green.svg" alt="Llaves" class="img-fluid" @click="showModalLevels = true">
            <div class="text-content">
              <h6>Cohete Verde</h6>
              <p>¡Felicidades! Prepárate para nuevas aventuras.</p>
            </div>
          </div>
          <div class="grid-item-level">
            <img src="/img-version2/icons/rocket-gray.svg" alt="Temporada" class="img-fluid" @click="showModalLevels = true">
            <div class="text-content">
              <h6>Cohete Gris</h6>
              <p>No pierdas la oportunidad de ganar grandes premios.</p>
            </div>
          </div>
          <div class="grid-item-level">
            <img src="/img-version2/icons/rocket-blue.svg" alt="Diamantes" class="img-fluid" @click="showModalLevels = true">
            <div class="text-content">
              <h6>Cohete Azul</h6>
              <p>Prepárate, pronto podrás participar.</p>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Contenido para usuarios STAFF -->
      <div v-if="isStaffUser()" class="glossary-container">
        <div class="header-ranking">
          <div class="d-flex align-items-center">
            <img src="/img-version2/icons/season/closed-chest.png" alt="close-chest" class="me-2">
            <h5 class="text-title-bat text-indigo">Tu ranking</h5>
          </div>
          <h6 class="text-bat lh-base">
            Prepárate para nuevos desafíos cada semana y gana recompensas increíbles. Cada llama representa tu estado actual:
          </h6>
        </div>
        <div class="grid-level text-bat">
          <div class="grid-item-level">
            <img src="/img-version2/icons/season-staff/season-current.gif" alt="Cofre" class="img-fluid" @click="showModalLevels = true">
            <div class="text-content">
              <h6>Llama gris y naranja</h6>
              <p>Estás avanzando. ¡Sigue completando actividades!</p>
            </div>
          </div>
          <div class="grid-item-level">
            <img src="/img-version2/icons/season-staff/season-won.gif" alt="Llaves" class="img-fluid" @click="showModalLevels = true">
            <div class="text-content">
              <h6>Llama con naranja y amarillo</h6>
              <p>¡Felicidades! Vas por excelente camino. Se vienen nuevas aventuras.</p>
            </div>
          </div>
          <div class="grid-item-level">
            <img src="/img-version2/icons/season-staff/gray-flame.svg" alt="Temporada" class="img-fluid" @click="showModalLevels = true">
            <div class="text-content">
              <h6>Llama gris con X roja</h6>
              <p>Ya perdiste la racha, pero aún puedes seguir sumando puntos. ¡No te detengas!</p>
            </div>
          </div>
          <div class="grid-item-level">
            <img src="/img-version2/icons/season-staff/blocked-flame.svg" alt="Diamantes" class="img-fluid" @click="showModalLevels = true">
            <div class="text-content">
              <h6>Llama gris punteada</h6>
              <p>Muy pronto podrás unirte y empezar a participar.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      url_storage: {
        default: null,
      },
      staff_segments: {
        default: 0,
      },
      client_segment: {
        type: Number,
        default: null,
      },
    },
    data() {
      return {
        showModalLevels: false,
      };
    },
    methods: {
    isStaffUser() {
      return this.staff_segments.includes(this.client_segment);
    },
  },
  }
  </script>
  